<template>
    <div id="HsheaderSearch" v-if="without_head">
        <div class="hs-search-content kycwidth">
            <router-link :to="{path:'/',query:{}}">
                <div class="hs-img-log" title="道琼斯黑名单查询系统" style="cursor: pointer"><img
                    src="../../assets/images/kyc_logo@2x.png" alt="" height="38px" width="159px">
                </div>
            </router-link>
            <inputGroup :currtab=currtab></inputGroup>
            <div class="hs-user headmenu hs-ul">
                <ul class="UserName-select" @click.stop="ifShowPersonalUl=!ifShowPersonalUl">
                    <li><i class="fa fa-user-circle-o fa-lg"></i></li>
                    <li class="hs-spacer"></li>
                    <li class="telName">{{userName}}</li>
                    <li><i class="fa fa-caret-down fa-lg"></i></li>
                </ul>
                <ul class="hs-select-css hs-use-ul" v-if="ifShowPersonalUl">
                    <li class="li_1">
                        <router-link
                            :to="{path:'/personalCenter/firmMonitorList',query:{random: Math.floor(Math.random() * 10)}}">
                            {{ $t('PCMonitorEnterprise') }}
                        </router-link>
                    </li>
                    <li class="li_2">
                        <router-link
                            :to="{path:'/personalCenter/personMonitorList',query:{random: Math.floor(Math.random() * 10)}}">
                            {{ $t('PCMonitorIndividual') }}
                        </router-link>
                    </li>
                    <li class="li_3" v-if="isDQS">
                        <router-link
                            :to="{path:'/personalCenter/artificialCheckDQS/artificialCheckDQSFirst',query:{random: Math.floor(Math.random() * 10)}}">
                            {{ $t('GlobalCheck') }}
                        </router-link>
                    </li>
                    <li class="li_3" v-else>
                        <router-link
                            :to="{path:'/personalCenter/artificialCheck',query:{random: Math.floor(Math.random() * 10)}}">
                            {{ $t('GlobalCheck') }}
                        </router-link>
                    </li>
                    <!-- 名单管理 12.27 -->
                    <!-- <li class="li_4">
                      <router-link :to="{path:'/personalCenter/listManage',query:{random: Math.floor(Math.random() * 10)}}">{{ $t('GlobalCheck') }}</router-link>
                    </li> -->
                    <li class="li_5">
                        <router-link
                            :to="{path:'/personalCenter/financialReportList',query:{random: Math.floor(Math.random() * 10)}}">
                            {{ $t('financialReport') }}
                        </router-link>
                    </li>
                    <li class="li_6">
                        <router-link
                            :to="{path:'/personalCenter/opinionCollect',query:{random: Math.floor(Math.random() * 10)}}">
                            {{ $t('PublicStatement') }}
                        </router-link>
                    </li>
                    <li class="li_7">
                        <router-link
                            :to="{path:'/personalCenter/ReportManager',query:{random: Math.floor(Math.random() * 10)}}">
                            {{ $t('ReportManager') }}
                        </router-link>
                    </li>
                    <li class="hs-signout" @click="signOut()">{{ $t('SignOut') }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import inputGroup from './inputGroup'

    export default {
        components: {inputGroup},
        props: ['currtab'],
        data() {
            return {
                userName: this.getCookie('user_Name') || localStorage.getItem('mobile_tel'),
                ifShowPersonalUl: false, // 默认不显示个人中心下拉列表
                without_head: true, // 是否展示头部，默认展示（嵌入式有需求不展示）
                isDQS:false
            }
        },
        created() {
            var without_head = sessionStorage.getItem('without_head')
            if (without_head && Number(without_head) === 1) {
                this.without_head = false
            }
            //黑名单查询-区分是否是道琼斯还是路透
            let channel = localStorage.getItem('channel')
            if (channel == '1') {
                this.isDQS = true
            } else {
                this.isDQS = false
            }
        },
        mounted() {
            var _this = this
            document.querySelector('body').addEventListener('click', function (ev) {
                _this.ifShowPersonalUl = false
            })
        }
    }
</script>
<style scoped>
    @import "../../assets/css/header/stockHeader.css";
</style>



// WEBPACK FOOTER //
// src/components/header/stockHeader.vue